import axios from 'axios';
import qs from 'qs';
import bus from '@/bus';

const service = axios.create();

service.interceptors.request.use(
  request => {
    // 统计页面定时刷新cpu数据,取消loading状态
    if (qs.stringify(request.data).indexOf('noLoading=true') === -1) {
      bus.$emit('backLoading');
    }
    if (request.data) {
      if (!(request.data instanceof FormData)) {
        if (sessionStorage.getItem('userId')) {
          request.data.userId = request.data.userId || sessionStorage.getItem('userId');
          request.data.sessionId = sessionStorage.getItem('sessionId');
        }
        if (request.data.login === '1') {
          request.data = {};
        }
        if (!request[0] && request[0] !== 'noFormData') {
          request.data = qs.stringify(request.data);
        }
      } else {
        request.data.append('userId', sessionStorage.getItem('userId'));
        request.data.append('sessionId', sessionStorage.getItem('sessionId'));
      }
    }
    return request;
  },
  err => {
    return Promise.reject(err);
  });
service.interceptors.response.use(
  response => {
    bus.$emit('backLoadEnd');
    if (response.status !== 200) {
      throw new Error('请求出错');
    } else {
      if (response.data.code === 'NOAUTH') {
        bus.$emit('login-overdue');
      }
      if (response.data.code === 'E') {
        bus.$emit('error-message', response.data.message);
      }
      return response.data;
    }
  });

export default service;



// WEBPACK FOOTER //
// ./src/api/fetch.js